import Log, {Errors} from "@khan/logging";

export type SortOrder =
    | "TOP"
    | "RECENT"
    | "HOT"
    | "OFFICIAL"
    | "UPVOTE"
    | "OLDEST";

export function normalizeSortOrder(raw: string): SortOrder {
    switch (raw) {
        case "top":
        case "TOP":
            return "TOP";
        case "recent":
        case "RECENT":
            return "RECENT";
        case "hot":
        case "HOT":
            return "HOT";
        case "spotlight":
        case "OFFICIAL":
            return "OFFICIAL";
        case "votes":
        case "UPVOTE":
            return "UPVOTE";
        case "oldest":
        case "OLDEST":
            return "OLDEST";
        default:
            Log.error(
                "Got unrecognized program sort order code " + raw,
                Errors.Internal,
            );
            return "TOP";
    }
}
